import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "dark:bg-input/30 shadow-xs flex h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base outline-none transition-[color,box-shadow] selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:ring-accent-lilac/50 focus-visible:border-accent-lilac focus-visible:ring-[3px]",
        "[&[aria-invalid=true]]:border-destructive [&[aria-invalid=true]]:ring-destructive-50 [&[aria-invalid=true]:focus-visible]:border-destructive [&[aria-invalid=true]:focus-visible]:ring-destructive-50",
        className
      )}
      {...props}
    />
  )
}

Input.displayName = "Input"

export { Input }
